import axios from 'axios'

export default {
    namespaced: true,

    state: {
        authenticated: sessionStorage.getItem('authenicated') || false,
        user: {student_id: null, student_name: null},
        userName: sessionStorage.getItem('user_name') || null,
        overlay: false,
        dialog: false,
        loginErrors: '',       
        newPassword: '',
        displayPasswordChanged: false,
        validStudentID: false,
        userInitials: sessionStorage.getItem('user_initials') || null,
        schoolName: process.env.VUE_APP_THEME_SCHOOL, 
        authToken: sessionStorage.getItem('auth_token') || null,
        studentId: sessionStorage.getItem('student_id') || null,
    },

    getters: {
        getAuthenticated (state) {
            return state.authenticated
        },

        getUser (state) {
            return state.user
        },

        getUserId (state) {
            return state.user.student_id
        },

        getUserName(state){
            return state.userName
        },

        getOverlay(state){
            return state.overlay
        },

        getDialog(state){
            return state.dialog
        },

        getLoginErrors(state){
            return state.loginErrors
        },       

        getNewPassword(state){
            return state.newPassword
        },

        getDisplayPasswordChanged(state){
            return state.displayPasswordChanged
        },

        getStudentIDValidation(state){
            return state.validStudentID
        },

        getUserInitials(state){
            return state.userInitials
        },

        getSchoolName (state) {
            return state.schoolName
        },

        getAuthToken (state) {
            return state.authToken
        },

        getStudentId (state) {
            return state.studentId
        },
    },

    mutations: {
        setAuthenticated (state, value) {
            state.authenticated = value
        },

        setUser (state, value) {
            state.user = value
        },

        setUserId (state, value){
            state.user.student_id = value;
        },

        setUserName (state, value){
            state.userName = value
        },

        setOverlay (state, value){
            state.overlay = value
        },

        setDialog(state, value){
            state.dialog = value
        },

        setLoginErrors(state, value){
            state.loginErrors = value
        },        

        setNewPassword(state, value){
            state.newPassword = value
        },

        setDisplayPasswordChanged(state, value){
            state.displayPasswordChanged = value
        },

        setStudentIDValidation(state, value){
            state.validStudentID = value
        },

        setUserInitials(state, value){
            state.userInitials = value
        },

        setAuthToken(state, value){
            state.authToken = value
        },

        setStudentId(state, value){
            state.studentId = value
        },
    },

    actions: {
        async signIn ({ commit }, credentials){ 
            commit('setOverlay', true);
                       
            try{
                await axios.get('/sanctum/csrf-cookie')
                
                const { data } = await axios.post('/api/login-student', credentials);  
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.auth_token;
              
                sessionStorage.setItem('auth_token', data.auth_token);
                sessionStorage.setItem('authenicated', data.id);
                sessionStorage.setItem('user_initials', data.first_name.trim()[0] + data.last_name.trim()[0]);
                sessionStorage.setItem('user_name', data.first_name + ' ' + data.last_name);
                sessionStorage.setItem('student_id', data.id);

                commit('setAuthToken', data.auth_token);
                commit('setAuthenticated', true);
                commit('setUser', credentials);
                commit('setUserInitials', data.first_name.trim()[0] + data.last_name.trim()[0]);
                commit('setUserName', data.first_name + ' ' + data.last_name); 
                commit('setStudentId', data.id);
                              
            } catch(error){
                if(error.response){
                    console.log(error.response);                        
                    commit('setLoginErrors', error.statusText);
                }
                else console.log(error);                
                commit('setAuthenticated', false);
                commit('setOverlay', false); 
            }

        },

        // student({ getters, commit }){
        //     commit('setUserInitials', getters.getStudentRecord.first_name.trim()[0] + getters.getStudentRecord.last_name.trim()[0]);
        //     commit('setUserRecord', {name: getters.getStudentRecord.first_name + ' ' + getters.getStudentRecord.last_name});                  
        // },

        async user({ getters, commit }){
            console.log("getting user information...");
            let url = '/api/user/' + getters.getUserId;           
            await axios.get(url)
                .then(response => {
                    console.log(response.status);
                    if(response.data.length != 0){
                        commit('setStudentIDValidation', true)
                        commit('setLoginErrors', '');
                        commit('setUserRecord', response.data[0]);                        
                    }
                    else{
                        commit('setLoginErrors', 'Student ID not found');
                        commit('setStudentIDValidation', false)
                        commit('setAuthenticated', false);
                        commit('setOverlay', false);                      
                    }                  
                })
        },        

        async signOut({commit}){                       
            await axios.post('/api/logout')
            sessionStorage.clear();
            commit('setAuthenticated', false); 
        },

       checkSession({dispatch}){           
           console.log(`Cookie Set: ${dispatch('cookieSet', 'ans_api_session')}`);
       },

       async getStudents(){
           try{
                return await axios.get('/api/students')
           }
           catch (error) {
                console.log(error);
           }
           
       },       

       cookieSet(cookieName){
           let name = cookieName + "=";
           let decodedCookie = decodeURIComponent(document.cookie);
           let cookies = decodedCookie.split(';');
           for(var i = 0; i < cookies.length; i++){
               var c = cookies[i];
               while(c.charAt(0) == ' '){
                   c = c.substring(1);
               }
               if(c.indexOf(name) == 0){
                    return true;
               }
           }
           return false;
       }
    }
}